import {FirmStatusFilterItem} from '~/components/advanced_table'
import {getEnvironmentStatuses} from '~/helpers'

const ORGANISATION_INVOICE_STATUSES = [
	{id: 'active', t: 'common.status.active'},
	{id: 'inactive', t: 'common.status.inactive'},
]

export const useOrganisationStatusFilter = () => {
	const filterFn = (invoice, filterValues) => {
		const {active} = getEnvironmentStatuses(invoice.organisationEnvironments)
		const status = active.length > 0 ? 'active' : 'inactive'
		return filterValues.includes(status)
	}

	return {
		items: ORGANISATION_INVOICE_STATUSES,
		filterFn,
		ItemComponent: FirmStatusFilterItem,
	}
}
